import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import HeaderStageComposition from '../../components/compositions/header/HeaderStage';
import GlobalSection from '../../components/basics/global/GlobalSection';
import YoutubePlayer from '../../components/basics/ui/UIYoutubePlayer';
import matchMediaConnector from '../service/ServiceMatchMedia';
import {
  isHardwareEntity,
  sortByAvailablePriority,
} from '../../helpers/entity';
import * as dialogActions from '../../actions/page/dialog';
import { DIALOG_TYPE_CUSTOM } from '../../helpers/constants';

class HeaderStage extends PureComponent {

  static mapEntitiesToItems({ items, entities }) {
    return items.map((item) => {
      const hardwareGroup = entities.find(entity => entity.eid === item.hardwareGroupEid);
      const hardwareList = entities
        .filter(isHardwareEntity)
        // filter all hardware entities that do not belong to the hardware group
        .filter(entity => entity.groupId === item.hardwareGroupEid)
        .sort(sortByAvailablePriority);
      return Object.assign({}, item, {
        hardwareGroup,
        hardwareName: hardwareGroup && hardwareGroup.name,
        hardware: hardwareGroup && hardwareList[0],
        tariff: entities.find(entity => entity.eid === item.tariffEid),
        isNew: hardwareGroup && hardwareGroup.new,
      });
    }, []);
  }

  constructor(props, context) {
    super(props, context);
    this.toggleVideo = this.toggleVideo.bind(this);
  }

  toggleVideo(videoId) {
    const { showDialog } = this.props;
    showDialog({
      type: DIALOG_TYPE_CUSTOM,
      component: YoutubePlayer,
      props: {
        videoId,
        width: '100%',
        height: '100%',
        autoPlay: true,
      },
    });
  }

  render() {
    const {
      entities,
      params,
      layoutSettings,
      isMediaS,
    } = this.props;

    const items = HeaderStage.mapEntitiesToItems({
      items: params.teaser,
      entities,
    });

    return (
      <GlobalSection
        layout="expanded"
        layoutSettings={layoutSettings}
        adjacent
      >
        <HeaderStageComposition
          items={items}
          onShowVideo={this.toggleVideo}
          isMediaS={isMediaS}
        />
      </GlobalSection>
    );
  }
}

HeaderStage.propTypes = {
  params: PropTypes.shape({
    teaser: PropTypes.arrayOf(PropTypes.shape({
      hardwareGroupEid: PropTypes.string,
      tariffEid: PropTypes.string,
    })),
  }),
  layoutSettings: PropTypes.object,
  entities: PropTypes.array,
  showDialog: PropTypes.func.isRequired,
  isMediaS: PropTypes.bool,
};

const mapDispatchToProps = {
  showDialog: dialogActions.showDialog,
};

export default compose(
  connect(null, mapDispatchToProps),
  matchMediaConnector(['isMediaS']),
)(HeaderStage);
